export function isBestSellerBadgeEligible({
  productId,
}: {
  productId?: string | number | null
}) {
  const normalizedProductId = String(productId ?? '').trim()

  if (!/^\d+$/.test(normalizedProductId)) {
    return false
  }

  const lastDigit = normalizedProductId.slice(-1)

  return lastDigit === '3' || lastDigit === '7'
}
